module.exports = {
  locale: 'en-US',
  messages: {
    'app.header.lang': '中文',
    'app.header.home': 'Home',
    'app.header.docs': 'Docs',
    'app.header.components': 'Components',
    'app.content.quote': 'Example Usage',
    'app.content.demo': 'Demo',

    'app.home.docs': 'Docs',
    'app.home.components': 'Components',
  },
};
